import { render, staticRenderFns } from "./accept.admission.vue?vue&type=template&id=6da0571b"
import script from "./accept.admission.vue?vue&type=script&lang=js"
export * from "./accept.admission.vue?vue&type=script&lang=js"
import style0 from "./accept.admission.vue?vue&type=style&index=0&id=6da0571b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports